export const novelInfo = {
  title: "二枪入一洞",
  author: "苏晓月",
  coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20martial%20arts%20novel%20book%20cover%20design%2C%20elegant%20dark%20ink%20wash%20painting%20style%2C%20ancient%20Chinese%20aesthetic%2C%20mysterious%20atmosphere%2C%20golden%20title%20text%2C%20traditional%20Chinese%20binding%20design%2C%20dramatic%20lighting%2C%20literary%20masterpiece%20feel&width=800&height=1200&seq=novel-cover-01&orientation=portrait",
  synopsis: "江湖风云变幻，一把名为「双龙」的神秘兵器横空出世，传说拥有它的人将掌握天下武学的至高奥秘。少年林逸自幼父母双亡，机缘巧合下得到「双龙」神兵，从此踏上了一条充满荆棘与奇遇的武道之路。然而，随着他逐渐揭开「双龙」背后隐藏的秘密，一个惊天阴谋也浮出水面——原来他的身世与这件神兵有着千丝万缕的联系。在友情与背叛、真相与谎言的交织中，林逸能否突破重重阻碍，成为真正的武道至尊？苏晓月以细腻的笔触勾勒出一个波谲云诡的江湖世界，人物刻画入木三分，情节环环相扣，是一部不可多得的武侠佳作。",
  status: "连载中",
  totalChapters: 1286,
  totalWords: "约380万字",
  updateFrequency: "每日更新",
  lastUpdate: "2026-08-06",
  category: "武侠仙侠",
  tags: ["热血", "江湖", "成长", "权谋", "奇遇"],
  rating: 9.6,
  ratingCount: 128500,
  favorites: 356000,
};

export const chapters: {
  id: number;
  title: string;
  content: string;
  wordCount: number;
  publishDate: string;
  volume: string;
}[] = [
  {
    id: 1,
    title: "第一章 风雪夜归人",
    volume: "第一卷·少年行",
    wordCount: 3215,
    publishDate: "2025-10-15",
    content: `北风如刀，鹅毛大雪席卷了整个青云山脉。

林逸紧了紧身上单薄的棉衣，脚下的积雪已经没过了脚踝，每走一步都异常艰难。他已经在这片荒山野岭中走了整整三天，干粮早已吃完，全凭一股求生的意志支撑着。

"再翻过前面那座山头，应该就到青石镇了……"他咬着牙，低声给自己打气。

夜色渐深，山林间传来阵阵狼嚎，令人毛骨悚然。林逸不由得加快了脚步，却不料一脚踩空，整个人顺着山坡滚了下去。

等他回过神来，发现自己跌进了一个隐蔽的山洞。洞内漆黑一片，伸手不见五指。林逸摸索着从怀中掏出火折子，微弱的光芒照亮了四周——这是一个不大的天然洞穴，石壁上爬满了藤蔓，地面上覆盖着厚厚的尘土。

正当他准备离开时，眼角余光瞥见洞穴深处似乎有什么东西在反光。好奇心驱使下，他小心翼翼地走了过去。

那是一把造型奇特的短兵器，通体呈墨黑色，却隐隐泛着幽蓝色的光芒。兵器的手柄处刻着两个古朴的文字——「双龙」。

林逸伸手握住兵器的那一刻，一股炽热的力量瞬间涌入他的体内，仿佛有什么东西在他脑海深处炸开了。

"这是……"

还没等他想明白，洞外突然传来了一阵急促的脚步声和说话声。

"那个小子应该就在这附近，给我仔细搜！活要见人，死要见尸！"

林逸心头一紧——那些人追来了。

他将「双龙」紧紧握在手中，深吸一口气，朝着洞穴更深处走去。他不知道前方等待他的是什么，但他知道，从握住这把神兵的那一刻起，他的命运已经彻底改变了。`,
  },
  {
    id: 2,
    title: "第二章 暗流涌动",
    volume: "第一卷·少年行",
    wordCount: 2987,
    publishDate: "2025-10-16",
    content: `青石镇是青云山脉脚下最大的集镇，南来北往的商旅络绎不绝，酒楼茶馆鳞次栉比。

林逸混在人群中进了镇子，在城东一家名叫「悦来客栈」的地方落了脚。他将「双龙」用布层层包裹，贴身藏好，不敢有丝毫大意。

一连三日，他都躲在客栈房间里，白天不出门，只在夜深人静时才会外出打探消息。他从那些追杀他的人留下的只言片语中拼凑出一个模糊的轮廓——他们来自一个叫做「血煞堂」的组织，而他们要找的，似乎不仅仅是这把兵器，还有他身上某种特殊的东西。

这天傍晚，林逸终于决定出门吃顿像样的饭。他挑了街角一家看起来还算干净的羊肉馆，要了一碗热腾腾的羊肉汤和两个烧饼。

正吃着，门口走进来三个人。为首的是一名身着白衣的年轻女子，眉目如画，气质清冷，腰间悬着一柄长剑。她身后跟着一男一女，皆是同样打扮，显然同出一门。

"掌柜的，三间上房，再准备一桌好菜。"女子开口，声音清冽如山泉。

林逸本不在意，但那女子经过他身边时，目光不经意间扫过他放在桌边的包裹——那包裹里，正是用布包着的「双龙」。

女子的脚步顿了顿，随即若无其事地走到另一张桌子坐下。

林逸心头一凛，匆匆吃完饭便要起身离开。

"且慢。"

白衣女子的声音从身后传来。林逸僵在原地，手已经悄悄握住了包裹。

"这位公子，你身上的东西……从哪里来的？"

林逸转过身，迎上那双清冷透彻的眼眸。他定了定神，反问道："什么东西？姑娘怕是认错人了。"

白衣女子微微一笑，那笑意却未及眼底："青云山深处的秘洞，三日前有人闯入，带走了封印其中的神器。整个江湖都已传遍——得「双龙」者，可得天下。"

她顿了顿，声音压低了几分："而现在，这把传说中的神兵，就在你身上。"`,
  },
  {
    id: 3,
    title: "第三章 青云剑派",
    volume: "第一卷·少年行",
    wordCount: 3056,
    publishDate: "2025-10-17",
    content: `白衣女子名叫柳如烟，乃是青云剑派掌门座下的首席弟子。她说青云剑派世代守护着「双龙」的秘密，而林逸闯入的那个山洞，正是三百年前封印神兵的禁地。

"你身上有天脉之血。"柳如烟盯着林逸的眼睛，一字一句地说道，"否则封印不可能被解开。三百年来，无数人尝试闯入禁地，但只有天脉血脉的传人才能破除封印，取出「双龙」。"

林逸愣住了。他从小便是孤儿，被一个老猎人收养长大，从未听说过什么天脉血脉。

柳如烟似乎看出了他的疑惑，继续解释道："天脉是上古时期最强大的武学血脉，据说拥有天脉之人修炼速度是常人的十倍，且能驾驭一切神兵利器。百年前，天脉家族惨遭灭门，所有人都以为天脉血脉已绝，没想到……"

她的话让林逸陷入了沉思。他的身世，他的养父从未提及的过去，以及养父临终前那句意味深长的嘱托——"逸儿，有些事，等你长大了自然就明白了"——这一切突然都有了一个模糊的指向。

窗外夜雨潇潇，客栈的灯火在风中摇曳。

柳如烟取出一封信笺，推到他面前："我师父——青云剑派掌门云中鹤，想见你。他知道关于你身世的秘密。"

林逸接过信笺，手指微微发颤。他抬起头，眼中闪过一丝决然："好，我去。"

青石镇到青云剑派，骑马需要三日。柳如烟说她会护送他一同前往，但林逸知道，这一路上绝不会太平。血煞堂的人还在追捕他，而「双龙」出世的消失一旦传开，整个江湖都会闻风而动。

黎明时分，四人悄然离开青石镇，踏上了前往青云剑派的路。林逸骑在马上，回头望了一眼身后在晨雾中渐渐模糊的镇子轮廓。他知道，从这一刻起，那个在雪山中艰难求生的少年已经不存在了——取而代之的，是一个被命运推上风口浪尖的江湖新丁。

前方的路，血雨腥风，也或许——柳暗花明。`,
  },
];

export const categoryList = [
  { slug: "wuxia", name: "武侠仙侠", count: 15280, icon: "ri-sword-line" },
  { slug: "xuanhuan", name: "玄幻奇幻", count: 23450, icon: "ri-magic-line" },
  { slug: "dushi", name: "都市言情", count: 18920, icon: "ri-building-line" },
  { slug: "lishi", name: "历史军事", count: 8930, icon: "ri-ancient-pavilion-line" },
  { slug: "kehuan", name: "科幻未来", count: 6750, icon: "ri-rocket-line" },
  { slug: "xuanli", name: "悬疑灵异", count: 5420, icon: "ri-ghost-line" },
  { slug: "youxi", name: "游戏竞技", count: 7820, icon: "ri-gamepad-line" },
  { slug: "duanpian", name: "短篇精选", count: 12600, icon: "ri-book-open-line" },
];

export interface NovelItem {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  rating: number;
  status: string;
  tags: string[];
}

export const categoryNovels: Record<string, NovelItem[]> = {
  wuxia: [
    { id: 1, title: "二枪入一洞", author: "苏晓月", coverImage: "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20style%20martial%20arts%20novel%20cover%2C%20ancient%20Chinese%20warriors%20with%20swords%20in%20misty%20mountains%2C%20elegant%20calligraphy%20title%2C%20traditional%20scroll%20design%2C%20dramatic%20chiaroscuro%20lighting%2C%20refined%20literary%20aesthetic&width=400&height=560&seq=novel-card-1&orientation=portrait", description: "少年林逸偶得神兵「双龙」，踏上武道巅峰之路，揭开身世之谜与江湖恩怨。", rating: 9.6, status: "连载中", tags: ["热血", "江湖", "成长"] },
    { id: 2, title: "剑道独尊", author: "叶孤城", coverImage: "https://readdy.ai/api/search-image?query=Martial%20arts%20novel%20cover%20with%20lone%20swordsman%20standing%20on%20cliff%20edge%20at%20sunset%2C%20ink%20wash%20painting%20aesthetic%2C%20golden%20clouds%2C%20ancient%20Chinese%20calligraphy%2C%20atmospheric%20and%20dramatic&width=400&height=560&seq=novel-card-2&orientation=portrait", description: "一剑西来，天下俯首。剑道天才的传奇人生，从无名小卒到剑道至尊。", rating: 9.3, status: "已完结", tags: ["剑道", "热血", "逆袭"] },
    { id: 3, title: "江湖风云录", author: "南宫逸", coverImage: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20wuxia%20novel%20cover%2C%20multiple%20warriors%20in%20combat%20poses%20on%20mountain%20peak%2C%20swirling%20clouds%2C%20ancient%20sword%20energy%20effects%2C%20epic%20scale%20cinematic%20composition&width=400&height=560&seq=novel-card-3&orientation=portrait", description: "乱世江湖，群雄逐鹿。一个普通镖师的崛起之路，揭开百年江湖秘密。", rating: 9.1, status: "连载中", tags: ["江湖", "权谋", "群像"] },
    { id: 4, title: "天下第一刀", author: "独孤行", coverImage: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20novel%20cover%20featuring%20a%20legendary%20saber%20with%20glowing%20blue%20energy%2C%20warrior%20silhouette%20against%20full%20moon%2C%20ancient%20temple%20background%2C%20mysterious%20and%20powerful%20atmosphere&width=400&height=560&seq=novel-card-4&orientation=portrait", description: "一刀断山河，一刀斩星辰。刀道至境，天下无双。", rating: 8.9, status: "已完结", tags: ["刀法", "热血", "修炼"] },
  ],
  xuanhuan: [
    { id: 5, title: "星辰变", author: "天蚕土豆", coverImage: "https://readdy.ai/api/search-image?query=Fantasy%20novel%20cover%20with%20cosmic%20starry%20sky%20and%20ancient%20Chinese%20cultivator%20floating%20in%20space%2C%20nebula%20colors%2C%20mystical%20runes%2C%20epic%20fantasy%20illustration%20style&width=400&height=560&seq=novel-card-5&orientation=portrait", description: "一颗神秘的星辰珠，一个少年逆天改命的传奇。", rating: 9.5, status: "已完结", tags: ["修炼", "星辰", "逆天"] },
    { id: 6, title: "斗破苍穹", author: "天蚕土豆", coverImage: "https://readdy.ai/api/search-image?query=Epic%20fantasy%20novel%20cover%20with%20flame%20warrior%20breaking%20through%20sky%2C%20dramatic%20orange%20and%20red%20color%20scheme%2C%20ancient%20ruins%2C%20power%20awakening%20scene&width=400&height=560&seq=novel-card-6&orientation=portrait", description: "三十年河东三十年河西，莫欺少年穷！废柴少年的逆袭之路。", rating: 9.7, status: "已完结", tags: ["废柴逆袭", "斗气", "热血"] },
  ],
  dushi: [
    { id: 7, title: "都市最强赘婿", author: "江南烟雨", coverImage: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20novel%20cover%2C%20sophisticated%20businessman%20silhouette%20against%20city%20skyline%20at%20night%2C%20warm%20amber%20lighting%2C%20elegant%20contemporary%20design%20with%20Chinese%20aesthetic%20elements&width=400&height=560&seq=novel-card-7&orientation=portrait", description: "入赘三年，他默默隐忍。一朝觉醒，翻手为云覆手为雨。", rating: 9.0, status: "连载中", tags: ["赘婿", "都市", "逆袭"] },
    { id: 8, title: "总裁的替身新娘", author: "慕容雪", coverImage: "https://readdy.ai/api/search-image?query=Modern%20romance%20novel%20cover%2C%20elegant%20woman%20in%20red%20dress%20against%20luxurious%20penthouse%20background%2C%20soft%20romantic%20lighting%2C%20sophisticated%20contemporary%20aesthetic%20with%20subtle%20Chinese%20elements&width=400&height=560&seq=novel-card-8&orientation=portrait", description: "她只是替身，却走进了他的心里。一场交易，一段虐恋。", rating: 8.8, status: "已完结", tags: ["豪门", "虐恋", "甜宠"] },
  ],
};

export const characters = [
  { name: "林逸", role: "主角", description: "天脉血脉传人，自幼父母双亡，机缘巧合下获得神兵「双龙」，踏上武道之路。性格坚韧果敢，重情重义。", quote: "我命由我不由天，这条路，我自己走。" },
  { name: "柳如烟", role: "女主角", description: "青云剑派首席弟子，冷若冰霜的外表下藏着一颗炽热的心。剑术超群，是林逸最重要的伙伴和知己。", quote: "有些事，明知不可为，也必须为之。" },
  { name: "血煞堂主", role: "反派", description: "江湖第一杀手组织血煞堂的首领，身份成谜，武功深不可测。与天脉家族灭门案有着千丝万缕的联系。", quote: "这个江湖，从来就不是讲道理的地方。" },
  { name: "云中鹤", role: "师父", description: "青云剑派掌门，武林泰斗级人物。知晓林逸身世的秘密，是引领林逸走上正道的关键人物。", quote: "剑之道，不在于锋芒，而在于心。" },
];

export const reviews = [
  { user: "江湖故人", rating: 10, date: "2026-08-05", content: "这部小说真的绝了！苏晓月的文笔细腻入微，人物刻画入木三分，林逸的成长历程让人感同身受。每一章都看得我热血沸腾，根本停不下来！强烈推荐！" },
  { user: "月下独酌", rating: 9, date: "2026-08-04", content: "近两年看过最好的武侠小说，没有之一。剧情环环相扣，伏笔埋得恰到好处。柳如烟这个角色塑造得太好了，既不是花瓶也不是工具人，是真正的灵魂伴侣。" },
  { user: "清风徐来", rating: 10, date: "2026-08-03", content: "已经追了半年了，每天等更新等得心痒痒。苏晓月大大求加更！这一卷的高潮部分写得让人拍案叫绝，反转来得猝不及防又合情合理。" },
  { user: "墨染青衣", rating: 9, date: "2026-08-02", content: "从第一章就开始追的老读者了。不得不说，「双龙」这个设定太巧妙了，既是神兵利器，又是伏笔线索。作者的叙事功力真的越来越强了。" },
  { user: "仗剑天涯", rating: 10, date: "2026-08-01", content: "一口气看完了三百章，眼睛都快瞎了但根本舍不得放下。这就是好小说的魔力！每个人的命运都环环相扣，江湖的残酷与人性的温暖在这里完美交融。" },
];

export const faqList = [
  { question: "《二枪入一洞》目前更新到多少章了？", answer: "截至2026年8月，小说已更新至1286章，总字数约380万字，目前仍在连载中，每日更新。" },
  { question: "在哪里可以免费阅读《二枪入一洞》？", answer: "您可以在本站及各主流阅读平台免费阅读本书。我们提供最新章节的及时更新和完整章节目录，方便您随时追更。" },
  { question: "《二枪入一洞》主要讲述了什么故事？", answer: "小说讲述了少年林逸偶得神兵「双龙」后，逐步揭开身世之谜，在江湖恩怨中成长并最终成为武道至尊的故事。融合了武侠、权谋、热血等多种元素。" },
  { question: "苏晓月还有哪些其他作品？", answer: "苏晓月是知名网络小说作家，除《二枪入一洞》外，还创作了《剑影江湖》《长安旧事》等作品，均获得了极高的读者评价。" },
  { question: "小说会改编成影视剧吗？", answer: "据可靠消息，《二枪入一洞》的影视改编权已被知名影视公司购得，目前正在筹备中，敬请期待。" },
];

export const aboutInfo = {
  brandIntro: "书香阁是一个专注于中文网络小说阅读与推荐的优质平台。我们致力于为读者提供最丰富的网络小说资源和最优质的阅读体验。自成立以来，书香阁已收录超过十万部精品小说，涵盖武侠仙侠、玄幻奇幻、都市言情、历史军事、科幻未来等众多品类，日均活跃读者超过百万人次。",
  mission: "让每一位读者都能找到属于自己的精神世界，让每一部好作品都能被更多人发现。",
  reputation: [
    { label: "累计读者", value: "580万+" },
    { label: "收录作品", value: "12万+" },
    { label: "日均阅读", value: "320万次" },
    { label: "好评率", value: "98.6%" },
  ],
  contact: {
    email: "contact@shuxiangge.com",
    wechat: "书香阁官方",
    weibo: "@书香阁官方微博",
    address: "北京市朝阳区文化创意产业园A座",
    phone: "400-888-6688",
  },
};